import React, { useState, useEffect } from 'react';
import { Server, AlertTriangle, CheckCircle, XCircle } from 'lucide-react';
import config from '../config/config';

const BackendStatus = () => {
  const [status, setStatus] = useState('checking');
  const [details, setDetails] = useState('');

  const checkBackendStatus = async () => {
    try {
      setStatus('checking');
      setDetails('Verificando conexión...');

      const response = await fetch(`${config.API_BASE_URL}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        signal: AbortSignal.timeout(10000) // 10 segundos
      });

      if (response.ok) {
        const data = await response.json();
        setStatus('connected');
        setDetails(`Backend funcionando - ${data.message}`);
      } else {
        setStatus('error');
        setDetails(`Error ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      setStatus('error');
      if (error.name === 'AbortError') {
        setDetails('Timeout: El servidor no responde');
      } else if (error.message.includes('Failed to fetch')) {
        setDetails('No se puede conectar al servidor. Verifica que esté ejecutándose.');
      } else {
        setDetails(`Error: ${error.message}`);
      }
    }
  };

  useEffect(() => {
    checkBackendStatus();
  }, []);

  const getStatusInfo = () => {
    switch (status) {
      case 'connected':
        return {
          icon: <CheckCircle className="h-5 w-5 text-green-500" />,
          color: 'text-green-600',
          bgColor: 'bg-green-50',
          title: 'Backend Conectado'
        };
      case 'error':
        return {
          icon: <XCircle className="h-5 w-5 text-red-500" />,
          color: 'text-red-600',
          bgColor: 'bg-red-50',
          title: 'Error de Conexión'
        };
      case 'checking':
        return {
          icon: <AlertTriangle className="h-5 w-5 text-yellow-500" />,
          color: 'text-yellow-600',
          bgColor: 'bg-yellow-50',
          title: 'Verificando...'
        };
      default:
        return {
          icon: <Server className="h-5 w-5 text-gray-500" />,
          color: 'text-gray-600',
          bgColor: 'bg-gray-50',
          title: 'Estado Desconocido'
        };
    }
  };

  const statusInfo = getStatusInfo();

  return (
    <div className={`p-4 rounded-lg border ${statusInfo.bgColor}`}>
      <div className="flex items-center space-x-3 mb-2">
        {statusInfo.icon}
        <h3 className={`font-semibold ${statusInfo.color}`}>
          {statusInfo.title}
        </h3>
      </div>
      
      <p className="text-sm text-gray-600 mb-3">
        {details}
      </p>
      
      <div className="space-y-2 text-xs text-gray-500">
        <div>URL del Backend: {config.API_BASE_URL}</div>
        <div>Endpoint de Prueba: {config.API_BASE_URL}/health</div>
      </div>
      
      {status === 'error' && (
        <div className="mt-3 p-3 bg-red-100 rounded border border-red-200">
          <h4 className="font-medium text-red-800 mb-2">Solución:</h4>
          <ol className="text-sm text-red-700 space-y-1">
            <li>1. Abre una terminal en la carpeta del backend</li>
            <li>2. Ejecuta: <code className="bg-red-200 px-1 rounded">npm start</code></li>
            <li>3. Verifica que aparezca: "Servidor corriendo en puerto 3317"</li>
            <li>4. Recarga esta página</li>
          </ol>
        </div>
      )}
      
      <button
        onClick={checkBackendStatus}
        className="mt-3 px-3 py-1 bg-blue-500 text-white text-sm rounded hover:bg-blue-600 transition-colors"
      >
        Reintentar Conexión
      </button>
    </div>
  );
};

export default BackendStatus;
